import { useEffect, useState } from "react";
import {
  Config,
  PropsGetterArgs,
  usePopperTooltip,
} from "react-popper-tooltip";
import styled from "styled-components";

import { borderRadius } from "~/styles/mixins";

export const TooltipContainer = styled.div.attrs({
  className: "tooltip-container",
})`
  ${borderRadius()};
`;

export const TooltipArrow = styled.div.attrs({
  className: "tooltip-arrow",
})``;

export const MenuTooltipContainer = styled(TooltipContainer)`
  padding: 0;
`;

export const useMenuTooltip = (config?: Config) => {
  const [controlledVisible, setControlledVisible] = useState(false);

  const { getTooltipProps, ...rest } = usePopperTooltip({
    trigger: "click",
    placement: "bottom-end",
    // react-popper-tooltip defaults to `interactive: false`, which its own
    // imported stylesheet (react-popper-tooltip/dist/styles.css, imported
    // globally in static/styles-src/main.js) turns into
    // `[data-popper-interactive='false'] { pointer-events: none; }` - making
    // every menu item permanently unclickable regardless of z-index/stacking,
    // since the whole container is click-transparent. This is a real,
    // pre-existing bug (unrelated to any React 18/Mantine change - this
    // file and both CSS sources are untouched by that migration), just not
    // one that was hit until a menu happened to render on top of other
    // clickable content.
    interactive: true,
    visible: controlledVisible,
    onVisibleChange: setControlledVisible,
    ...config,
  });

  useEffect(() => {
    const handleKeyDown = ({ key }: KeyboardEvent) => {
      if (key === "Escape") setControlledVisible(false);
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return {
    setControlledVisible,
    getTooltipProps: (args?: PropsGetterArgs) => ({
      ...getTooltipProps(args),
      onClick: () => setControlledVisible(false),
    }),
    ...rest,
  };
};
